import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import ImportSOA from "@/pages/ImportSOA";
import Users from "@/pages/Users";
import Calendar from "@/pages/Calendar";
import CollectionsBoard from "@/pages/CollectionsBoard";
import Reports from "@/pages/Reports";
import OpenInvoices from "@/pages/OpenInvoices";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
                <Routes>
                    <Route path="/giris" element={<Login />} />
                    <Route
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route path="/panel" element={<Dashboard />} />
                        <Route path="/tahsilat" element={<CollectionsBoard />} />
                        <Route path="/musteriler" element={<Customers />} />
                        <Route path="/musteriler/:id" element={<CustomerDetail />} />
                        <Route path="/ice-aktar" element={<ImportSOA />} />
                        <Route path="/takvim" element={<Calendar />} />
                        <Route path="/raporlar" element={<Reports />} />
                        <Route path="/acik-faturalar" element={<OpenInvoices />} />
                        <Route
                            path="/kullanicilar"
                            element={
                                <ProtectedRoute adminOnly>
                                    <Users />
                                </ProtectedRoute>
                            }
                        />
                    </Route>
                    <Route path="/" element={<Navigate to="/panel" replace />} />
                    <Route path="*" element={<Navigate to="/panel" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
